import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock, Dumbbell, Zap } from 'lucide-react';
type FallProgram = {
  eyebrow: string;
  title: string;
  duration: string;
  schedule: string;
  description: string;
  note?: string;
};
const FALL_PROGRAMS: FallProgram[] = [{
  eyebrow: 'Homeschool Athletes',
  title: 'Homeschool Multisport',
  duration: '90-minute sessions',
  schedule: 'Tue and Thu · 2:30 to 4:00 PM',
  description: 'A dedicated athletic period for homeschool athletes. Build speed, strength, coordination, and movement skills in a coached small group.',
  note: 'Founding rate $325 through Aug 9, then $400.'
}, {
  eyebrow: 'Middle School · Ages 11 to 13',
  title: 'Performance Prep',
  duration: '60-minute sessions',
  schedule: 'Tue and Thu · 4:45 to 5:45 PM',
  description: 'Performance Prep builds speed, strength, and change-of-direction mechanics for middle school athletes.'
}, {
  eyebrow: 'High School · Ages 14+',
  title: 'Advanced Court',
  duration: '75-minute sessions',
  schedule: 'Tue and Thu · 5:45 to 7:00 PM',
  description: 'For basketball and volleyball athletes. Court athletes train for the demands of their sport.'
}, {
  eyebrow: 'High School · Ages 14+',
  title: 'Advanced Field',
  duration: '75-minute sessions',
  schedule: 'Tue and Thu · 7:00 to 8:15 PM',
  description: 'For soccer, baseball, lacrosse, and football athletes. Field athletes train for the demands of their sport.'
}];
export function Programs() {
  return <div className="w-full bg-white" data-id="element-753" data-mp="1snp6fcbvmm0m">
      <Hero data-id="element-754" data-mp="1smmjtgll75qi" />
      <SeasonIntro data-id="element-755" data-mp="1sn60yv3exq3h" />
      <FallPrograms data-id="element-756" data-mp="1sll6t6l0g965" />
      <Methodology data-id="element-757" data-mp="1np485ig6qcet" />
      <NextStepBand data-id="element-758" data-mp="1nokw2id7ui8p" />
    </div>;
}
function Hero() {
  return <section className="relative overflow-hidden bg-reach-black" data-id="element-759" data-mp="3ufaqjzxfwbb1">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-760" data-mp="3ufke7gv0i6dk">
        <div className="absolute top-1/4 -left-40 h-1.5 w-[50%] -rotate-[6deg] bg-reach-red opacity-50" data-id="element-761" data-mp="3phiwaz9bod3o" />
        <div className="absolute top-[42%] -left-40 h-1.5 w-[35%] -rotate-[6deg] bg-reach-red opacity-30" data-id="element-762" data-mp="1tenmait6yvnq" />
        <div className="absolute top-[60%] -left-40 h-1.5 w-[25%] -rotate-[6deg] bg-reach-red opacity-20" data-id="element-763" data-mp="1ycpdjr0ru1aa" />
      </div>
      <div className="relative z-10 mx-auto flex h-[280px] max-w-container flex-col items-center justify-center px-4 text-center md:h-[320px] md:px-8" data-id="element-764" data-mp="22fvhgs0evgdl">
        <p className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-765" data-mp="2cavw7zx5fupd">
          Fall 2026 · August 11 to December 17
        </p>
        <h1 className="mb-3 font-bebas text-6xl leading-none tracking-wide text-white md:text-8xl" data-id="element-766" data-mp="2m1qg4xmxai7n">
          Fall Programs
        </h1>
        <p className="max-w-2xl font-inter text-base text-white/85 md:text-xl" data-id="element-767" data-mp="2q2afm7uyxxwy">
          Tuesday and Thursday training for homeschool, middle school, and high school athletes.
        </p>
      </div>
    </section>;
}
function SeasonIntro() {
  return <section className="bg-white py-16 md:py-20" data-id="element-768" data-mp="3a5gc6qolytff">
      <div className="mx-auto max-w-3xl px-4 text-center md:px-8" data-id="element-769" data-mp="3a699l11og6kw">
        <p className="font-inter text-lg leading-relaxed text-reach-black md:text-xl" data-id="element-770" data-mp="355u0wmscbn99">
          Start with the group that fits your athlete. Review the Fall 2026 schedule, then choose the right pricing plan.
        </p>
      </div>
    </section>;
}
function FallPrograms() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-771" data-mp="3svocl10xb5rx">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-772" data-mp="3sv667bkjrb6a">
        <div className="mb-14 text-center" data-id="element-773" data-mp="3nwl3n5htofeo">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-774" data-mp="3nxmpm50dmmb6">
            Programs And Class Times
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-6xl" data-id="element-775" data-mp="3f5cgkr17wmvi">Choose Your Group</h2>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-776" data-mp="fi31tlih5w3i">
          {FALL_PROGRAMS.map(program => <article key={program.title} className="flex min-h-[370px] flex-col border-b-4 border-transparent bg-white p-7 transition-colors duration-200 hover:border-reach-red" data-id="element-777" data-mp="ap1kl6uspkgr">
              <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.25em] text-reach-red" data-id="element-778" data-mp="51t1xq2jnwc">
                {program.eyebrow}
              </p>
              <h3 className="mb-4 font-bebas text-3xl leading-none tracking-wide" data-id="element-779" data-mp="3mfe6w9lhlcou">{program.title}</h3>
              <div className="mb-5 flex items-center gap-2 font-inter text-sm text-reach-black/70" data-id="element-780" data-mp="dzcm2r93m487">
                <Clock size={14} className="text-reach-red" aria-hidden="true" data-id="element-781" data-mp="ixe4d9yp9zim" />
                <span className="uppercase tracking-wider" data-id="element-782" data-mp="55g3fmf579xj">{program.duration}</span>
              </div>
              <div className="border-t border-black/10 pt-4" data-id="element-783" data-mp="971cewok342g">
                <div className="mb-4 flex items-start gap-2 font-inter text-sm font-semibold leading-relaxed text-reach-black" data-id="element-784" data-mp="wxxa2afp0thm">
                  <Calendar size={15} className="mt-0.5 shrink-0 text-reach-red" aria-hidden="true" data-id="element-785" data-mp="11pf9uv5zco10" />
                  <span data-id="element-786" data-mp="2mdr7h2xvywb9">{program.schedule}</span>
                </div>
                <p className="font-inter text-base leading-relaxed text-reach-black/80" data-id="element-787" data-mp="2hfzbnxu4eq1s">{program.description}</p>
              </div>
              {program.note && <p className="mt-auto pt-5 font-inter text-sm font-semibold leading-relaxed text-reach-black" data-id="element-788" data-mp="2w6oqda6sinae">
                  {program.note}
                </p>}
            </article>)}
        </div>
      </div>
    </section>;
}
function Methodology() {
  return <section className="relative overflow-hidden bg-reach-black py-20 text-white md:py-24" data-id="element-789" data-mp="1yioj0w2zuuvb">
      <div className="pointer-events-none absolute -right-40 top-1/4 h-1 w-[50%] rotate-[6deg] bg-reach-red opacity-30" data-id="element-790" data-mp="2dffh920xm0jc" />
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-791" data-mp="28hdxsfzlfz7c">
        <div className="mx-auto max-w-3xl text-center" data-id="element-792" data-mp="3oryimo4rmft6">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-793" data-mp="3jugdz9xs6mqz">
            How We Train
          </p>
          <h2 className="mb-5 font-bebas text-4xl leading-none tracking-wide md:text-6xl" data-id="element-794" data-mp="3qwv1kq3639a4">
            Every Day Has A Purpose
          </h2>
          <p className="font-inter text-base leading-relaxed text-white/85 md:text-lg" data-id="element-795" data-mp="4q6jzl4kwl01">
            Speed and strength work are scheduled by day. Athletes train specific qualities through a planned weekly progression.
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-796" data-mp="3887ygd4jwtz6">
          <article className="border border-white/10 bg-white/[0.04] p-6 md:p-8" data-id="element-797" data-mp="3d71di9zhkt1g">
            <div className="mb-4 flex items-center gap-3" data-id="element-798" data-mp="3i4jbx6fvnpv7">
              <Zap size={22} className="text-reach-red" aria-hidden="true" data-id="element-799" data-mp="3i2zwtj5yjkv0" />
              <h3 className="font-bebas text-3xl tracking-wide" data-id="element-800" data-mp="3mxcg9t7fow6r">Speed Focus</h3>
            </div>
            <p className="font-inter leading-relaxed text-white/80" data-id="element-801" data-mp="2pfvy1vxgk2ro">
              Acceleration, change of direction, speed, and sport-specific movement.
            </p>
          </article>
          <article className="border border-white/10 bg-white/[0.04] p-6 md:p-8" data-id="element-802" data-mp="1bj2qyf0tgjj2">
            <div className="mb-4 flex items-center gap-3" data-id="element-803" data-mp="17iiuldo2hjxz">
              <Dumbbell size={22} className="text-reach-red" aria-hidden="true" data-id="element-804" data-mp="17gy0tq9ku516" />
              <h3 className="font-bebas text-3xl tracking-wide" data-id="element-805" data-mp="12lsewrg6cqd3">Strength Focus</h3>
            </div>
            <p className="font-inter leading-relaxed text-white/80" data-id="element-806" data-mp="xmp8p3ogke3j">
              Lower body, upper body, and total body strength work across the week.
            </p>
          </article>
        </div>
      </div>
    </section>;
}
function NextStepBand() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-807" data-mp="jtzlwx13v55d">
      <div className="mx-auto max-w-container px-4 text-center md:px-8" data-id="element-808" data-mp="eu3jh2823lrx">
        <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-white/80" data-id="element-809" data-mp="es0hdjtmq26u">
          Next Step
        </p>
        <h2 className="mb-4 font-bebas text-5xl tracking-wide text-white md:text-7xl" data-id="element-810" data-mp="4w74fzc006oj">
          Choose Your Fall Plan
        </h2>
        <p className="mx-auto mb-10 max-w-2xl font-inter text-lg text-white md:text-xl" data-id="element-811" data-mp="1trfvm8i8nmr8">
          Start with the Fall 2026 schedule. Then view pricing and enroll.
        </p>
        <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-812" data-mp="1jsgnqs5arv5a">
          <Link to="/fall-2026" className="inline-flex min-h-[44px] items-center justify-center rounded-[4px] bg-white px-6 font-inter text-sm font-semibold uppercase tracking-wide text-reach-black transition-all duration-200 ease-out hover:-translate-y-[3px] hover:bg-reach-black hover:text-white md:min-h-[48px] md:text-base" data-id="element-813" data-mp="1opgsmzqeurut">
            See The Fall 2026 Schedule <ArrowRight size={16} className="ml-2" data-id="element-814" data-mp="161bty6om1x2v" />
          </Link>
          <Link to="/pricing" className="btn-secondary-dark sm:w-auto" data-id="element-815" data-mp="r2rks9911l11">
            View Pricing
          </Link>
        </div>
      </div>
    </section>;
}